import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { CompanyService } from '../../../services/company.service';
import { LocationService } from '../../../services/location.service';
import { HttpClient, HttpHandler } from '@angular/common/http';


@Component({
  selector: 'app-location-picker',
  templateUrl: './location-picker.component.html',
  styleUrls: ['./location-picker.component.scss']
})
export class LocationPickerComponent implements OnInit, OnChanges {
  @Input() companyId: number;
  @Input() locationId: number;
  @Input() userLocationIds: number[];
  @Input() disable: boolean = false;
  @Input() _placeholder: string = 'Please Select';
  @Output() onLocationIdSet = new EventEmitter<number>();
  @Output() onLocationSet = new EventEmitter<any>();

  locations = [];
  locationList = [];
  location_Name: string;
  constructor(public locationService: LocationService, public companyService: CompanyService) {
  }

  ngOnInit(): void {
    this.locationService.getAll().then((locations) => {
      this.locationList = locations;
      this.locations = locations;

      if (this.companyId != null && this.companyId != undefined) {
        this.companyService.get(this.companyId).then((data) => {
          this.locations = this.locationList.filter(c => {
            return c.contract_No == data.contract_No;
          });

          this.updateClientPreferences();
        });

        
   

      }
      if (this.locationId != undefined && this.locationId > 0) {
        var location = this.locationList.find(a => a.id == this.locationId);
        this.location_Name = location.name;
      }
    });

  }
  updateClientPreferences() {
    //console.log(this.userLocationIds);
    if (this.userLocationIds != undefined && this.userLocationIds.length > 0) {
      this.locations = [];
      for (var i = 0; i < this.locationList.length; i++) {
        var loc = this.locationList[i];
        for (var ii = 0; ii < this.userLocationIds.length; ii++) {
          var ass = this.userLocationIds[ii];
          if (loc.id == ass)
            this.locations.push(loc);
        }
      }
    }
  }
  ngOnChanges(changes: SimpleChanges): void {

 
    if ((changes.locationId != null && changes.locationId.currentValue != null) || (changes.companyId != null && changes.companyId.currentValue != null)) {
      if (changes.locationId != null && this.locationId != changes.locationId.currentValue != null)
        this.locationId = changes.locationId.currentValue;

      if (changes.companyId != null && this.companyId != changes.companyId.currentValue != null)
        this.companyId = changes.companyId.currentValue;

      if (this.companyId != null && this.companyId != undefined) {
        if (this.companyService == undefined)
          this.companyService = new CompanyService(new HttpClient(null));
        this.companyService.get(this.companyId).then((data) => {
          //console.log(data);
          this.locations = this.locationList.filter(c => {
            return c.contract_No == data.contract_No;
          });
          this.updateClientPreferences();
        });

      } else {
        this.locations = this.locationList;
        if (this.locationId != undefined && this.locationId > 0) {
          var location = this.locationList.find(a => a.id == this.locationId);
          this.location_Name = location.name;
        }
      }

    }

    if (changes != undefined && changes.locationId == undefined && changes.companyId != undefined && changes.companyId.currentValue == undefined) {
      this.locationService.getAll().then((data) => {
        this.locationList = data;
        this.locations = this.locationList;

        if (this.locationId != undefined && this.locationId > 0) {
          var location = this.locationList.find(a => a.id == this.locationId);
          this.location_Name = location.name;
        }
        this.updateClientPreferences();
      });
    }

    if (changes != null && changes.userLocationIds != undefined && changes.userLocationIds != null && changes.userLocationIds.currentValue != null) {
      if (this.locationList != undefined) {
        this.updateClientPreferences();
      }
    }
  }

  onChanged() {
    this.onLocationIdSet.emit(this.locationId);
    var location = this.locations.find(a => a.id == this.locationId);
    this.onLocationSet.emit(location);

    //this.onCompanyIdSet.emit(this.locationId);
    //var location = this.locations.find(a => a.id == this.locationId);
    //
  }

}
